import { labeled, guidRequired, numberRequired, custom, enumRequired } from '../../util/joi';
import { paymentFrequencies } from '../global/PaymentFrequency.enum';

export const schema = (Joi: any, label: string) =>
  Joi.object()
    .keys({
      idContact: guidRequired(Joi).label(labeled(label, 'Linked contact'))
    })
    .when('.incomeType.id', {
      is: 'payg_income',
      then: Joi.object().keys({
        payg: custom(Joi)
          .object()
          .keys({
            grossSalary: Joi.number(),
            bonus: Joi.number(),
            overtimeEssential: Joi.number(),
            overtimeNonEssential: Joi.number(),
            commission: Joi.number(),
            allowance: Joi.number()
          })
          .orValue(
            'grossSalary',
            'bonus',
            'overtimeEssential',
            'overtimeNonEssential',
            'commission',
            'allowance'
          )
          .label(labeled(label, 'PAYG income -'))
          .when('.grossSalary', {
            is: Joi.number().not(0),
            then: Joi.object({
              grossSalaryFrequency: enumRequired(
                Joi,
                paymentFrequencies,
                labeled(label, 'Income Gross Salary Frequency')
              )
            })
          })
          .when('.bonus', {
            is: Joi.number().not(0),
            then: Joi.object({
              bonusFrequency: enumRequired(
                Joi,
                paymentFrequencies,
                labeled(label, 'Bonus Frequency')
              )
            })
          })
          .when('.overtimeEssential', {
            is: Joi.number().not(0),
            then: Joi.object({
              overtimeEssentialFrequency: enumRequired(
                Joi,
                paymentFrequencies,
                labeled(label, 'Overtime Essential Frequency')
              )
            })
          })
          .when('.overtimeNonEssential', {
            is: Joi.number().not(0),
            then: Joi.object({
              overtimeNonEssentialFrequency: enumRequired(
                Joi,
                paymentFrequencies,
                labeled(label, 'Overtime Non Essential Frequency')
              )
            })
          })
          .when('.commission', {
            is: Joi.number().not(0),
            then: Joi.object({
              commissionFrequency: enumRequired(
                Joi,
                paymentFrequencies,
                labeled(label, 'Commission Frequency')
              )
            })
          })
          .when('.allowance', {
            is: Joi.number().not(0),
            then: Joi.object({
              allowanceFrequency: enumRequired(
                Joi,
                paymentFrequencies,
                labeled(label, 'Allowance Frequency')
              )
            })
          })
      })
    })
    .when('.incomeType.id', {
      is: 'payg_income',
      then: Joi.object().keys({
        idEmployer: guidRequired(Joi).label(labeled(label, 'Payg Linked employer'))
      })
    })
    .when('.incomeType.id', {
      is: 'other_taxable_income',
      then: Joi.object({
        grossValue: numberRequired(Joi, 1).label(labeled(label, 'Other taxable gross value')),
        frequency: enumRequired(
          Joi,
          paymentFrequencies,
          labeled(label, 'Other taxable Frequency')
        )
      })
    })
    .when('.incomeType.id', {
      is: 'non_taxable_income',
      then: Joi.object({
        grossValue: numberRequired(Joi, 1).label(
          labeled(label, 'Non taxable income - Gross Value')
        ),
        frequency: enumRequired(
          Joi,
          paymentFrequencies,
          labeled(label, 'Non taxable income Frequency')
        )
      })
    });

export default {
  schema
};
